module.exports = __webpack_public_path__ + "static/buerjia-82ae15d29998b989fcdf97884d27d0dc.png";